module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-599.41ebba9.woff2";